import React from 'react';
import PropTypes from 'prop-types';

/**
 * React component that renders flucutation bulb component. Fluctuation bulb appears
 * below the highchart component.
 * @param {Bool} val - Properties used to render the component.
 * @returns {Element} React element.
 */
export class FluctuationBulb extends React.PureComponent {
  render() {
    this.bulbElem = React.createRef();
    const divStyle = {
      left: `${this.props.left}px`,
    };
    const { isRed, isYellow } = this.props;
    const normalClass = isYellow ? 'balloonYellow' : 'balloon';
    const balloonClass = isRed ? 'balloonUnknown' : normalClass;
    const balloonPic = <div className="fluc-image" id={this.props.id} />;

    return (
      <div className={balloonClass} style={divStyle} ref={this.bulbElem} id={this.props.id}>
        {balloonPic}
      </div>
    );
  }
}

FluctuationBulb.propTypes = {
  id: PropTypes.string.isRequired,
  isRed: PropTypes.bool.isRequired,
  isYellow: PropTypes.bool.isRequired,
  left: PropTypes.number.isRequired,
};
